import * as React from 'react';
import {Subject}  from 'rxjs';

import {PLAYER_CAPTIONS_MENU_OPTION} from '../../../../Shared/Constants/TestIds';
import UiEventType                   from '../../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload        from '../../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList              from '../../../Util/composeTokenList';
import renderTestId                  from '../../../Util/renderTestId';

import * as styles from './captionsOption.css';

interface ICaptionsOptionProps {
    uiEvents$: Subject<IUiEventsStreamPayload>;
    label: string;
    language: string;
    selected: boolean;
}

class CaptionsOption extends React.Component<ICaptionsOptionProps> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    public render(): JSX.Element {
        const optionClassName = composeTokenList([
            styles.option,
            [this.props.selected, styles.selected]
        ]);

        const testIdSuffix = this.props.language ? '_' + this.props.language.toUpperCase() : '_OFF';

        const testId = composeTokenList([
            PLAYER_CAPTIONS_MENU_OPTION,
            PLAYER_CAPTIONS_MENU_OPTION + testIdSuffix
        ]);

        return (
            <div
                className={optionClassName}
                data-test-id={renderTestId(testId)}
                onClick={this.handleClick}
            >
                <div className={styles.label}>
                    <div className={styles.icon}>
                        <div className={styles.circle} />
                    </div>
                    <div className={styles.labelText}>
                        {this.props.label}
                    </div>
                </div>
            </div>
        );
    }

    private handleClick(): void {
        const {language, uiEvents$} = this.props;
        uiEvents$.next({
            type: UiEventType.CAPTIONS_OPTION_TAP,
            eventData: {language}
        });
    }
}

export default CaptionsOption;